import { render, staticRenderFns } from "./CallManagementContent.vue?vue&type=template&id=2509ef8c&scoped=true&"
import script from "./CallManagementContent.vue?vue&type=script&lang=js&"
export * from "./CallManagementContent.vue?vue&type=script&lang=js&"
import style0 from "./CallManagementContent.vue?vue&type=style&index=0&id=2509ef8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2509ef8c",
  null
  
)

export default component.exports